import { type ActionItem } from 'shared/ui'

type IGetExportReportActionParams = {
  disabled: boolean
  onExport: () => void
}

export const getExportReportAction = ({
  disabled,
  onExport,
}: IGetExportReportActionParams): ActionItem => ({
  text: 'Export report',
  icon: 'download',
  onAction: onExport,
  buttonProps: {
    disabled,
    tooltipProps: disabled ? { label: 'No data to export.', placement: 'top' } : undefined,
  },
})
